import React, { useEffect } from 'react'

import { useLazyGetWorkOrderContainersQuery } from 'api/inventory/workOrderContainer'
import WorkOrderContainersSection from 'components/work-order/details/containers/WorkOrderContainersSection'
import { handleError } from 'utils/error'
import { get } from 'utils/lodash'

type WorkOrderContainersTabProps = {
  workOrderId?: string
  configuredServiceId?: string
}

// Containers for this specific work order (configured-service WO accordion). Reuses the WO-detail
// containers section: list + search + per-WO disable/restore, scoped to this work order.
const WorkOrderContainersTab: React.FC<WorkOrderContainersTabProps> = ({ workOrderId = '', configuredServiceId = '' }) => {
  const [getContainers, { data, isFetching }] = useLazyGetWorkOrderContainersQuery()

  useEffect(() => {
    if (workOrderId) getContainers({ workOrderId }).unwrap().catch(handleError)
  }, [workOrderId, getContainers])

  return (
    <WorkOrderContainersSection
      configuredServiceId={configuredServiceId}
      containers={get(data, 'containers', [])}
      containersLoaded={Boolean(data)}
      isFetching={isFetching}
      workOrderId={workOrderId}
    />
  )
}

export default WorkOrderContainersTab
